import $ from 'jquery';

export default class MfMatchController {
	constructor() {
		/** @type {any[]} */
		this.activeItem = [];

		this.create = undefined;

		/** @type {any} */
		this.match = undefined;

		/** @type {any} */
		this.openForm = false;
		this.order = undefined;
		this.mf = undefined;

		/** @type {any} */
		this.popup = undefined;

		/** @type {any} */
		this.postalAddress = undefined;

		this.query = undefined;

		/** @type {any} */
		this.select = undefined;

		/** @type {?import('../smart-field/smart-field.controller').default} */
		this.smartField = null;

		/** @type {any[]} */
		this.values = [];
	}

	isChecked() {
		return this.match.checked || (Array.isArray(this.values) && this.values.some(v => v.kid === this.match.kid));
	}

	expandMatch() {
		if (this.match.expanded) {
			this.mf.collapse(this.match);
		}
		else {
			this.mf.expand(this.match);
		}
	}

	getMatchName() {
		if (this.match.name_type_kid === 'K_NODE;DATE' && this.match.name) {
			return new Date(this.match.name).toLocaleString('short');
		}

		return this.match.name;
	}

	selectable() {
		return this.match.selectable === 1
			&& (
				!this.popup.multipleSelection && this.values && Array.isArray(this.values)
					? !this.values.map(v => v.kid).includes(this.match.kid)
					: true
			)
			&& (
				(this.mf && ((this.mf.uniqueKid && this.values !== this.match.kid) || !this.mf.uniqueKid))
				|| !this.mf
			);
	}

	/**
	 * @param {Event} event
	 */
	selectMatch(event) {
		// @ts-ignore
		if ($(event.target).hasClass('expand')) {
			this.expandMatch();
		}
		// @ts-ignore
		else if (this.mf && $(event.target).hasClass('checkbox-multiple-mf')) {
			if (this.mf.majpressed === true) {
				this.popup.selectAllChildrens(this.mf.matches);
			}
			else {
				this.popup.multiSelect(this.match, event);
			}
		}
		// @ts-ignore
		else if (!$(event.target).closest('a').hasClass('mf-open-form')) {
			if (this.mf) {
				this.mf.select(this.match, event);
			}
			else if (this.postalAddress) {
				this.postalAddress.select(this.match, event);
			}
			else if (typeof this.select === 'function') {
				this.select({ event, item: this.match });
			}
		}
		// @ts-ignore
		$(event.target).closest('a').trigger('blur');
	}

	isActive() {
		return this.match?.path?.length > 0 && this.match?.path?.join('.') === this.activeItem?.join('.');
	}

	isMagic() {
		return /^_.+_$/.test(this.match.kid);
	}

	$onInit() {
		if (!this.mf && this.popup.mf) {
			this.mf = this.popup.mf;
		}
	}
}
